import { z } from 'zod';
import { AuditEntryCategory } from '../enums/audits';

export * from './agents';
export * from './accounts';
export * from './account-features';
export * from './applications';
export * from './application-features';
export * from './auth-apps';
export * from './data-sources';
export * from './compliance';
export * from './search';
export * from './crm-connections';
export * from './form-schemas';
export * from './form-workflows';
export * from './pages';
export * from './prompts';

export namespace SearchAudits {
  export const RequestBodySchema = z.object({
    userIds: z.array(z.coerce.number()).optional(),
    groupIds: z.array(z.coerce.number()).optional(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    page: z.coerce.number().prefault(1),
    pageSize: z.coerce.number().prefault(100),
    categoryTypes: z.array(z.enum(AuditEntryCategory)).optional(),
  });

  export const ResponseSchema = z.object({
    audits: z.array(z.object({
      id: z.number(),
      user: z.object({
        id: z.number(),
        name: z.string(),
      }).nullable(),
      categoryType: z.enum(AuditEntryCategory),
      categoryData: z.record(z.string(), z.any()),
      createdOn: z.coerce.date(),
      contextData: z.object({
        ip: z.string().optional(),
        userAgent: z.string().optional(),
      }),
      code: z.enum(['success', 'failed']),
    })),
    total: z.number(),
  });
  export type RequestBody = z.infer<typeof RequestBodySchema>;
  export type Response = z.infer<typeof ResponseSchema>;
}